import { render } from "./employeeChats.vue?vue&type=template&id=2614d746&scoped=true&ts=true"
import script from "./employeeChats.vue?vue&type=script&lang=ts"
export * from "./employeeChats.vue?vue&type=script&lang=ts"

import "./employeeChats.vue?vue&type=style&index=0&id=2614d746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2614d746"]])

export default __exports__